import { useLayoutEffect, useRef, type ReactNode } from 'react';

/**
 * HeldHeight (row 359 B). The console scrolls on the WINDOW, so a table that shrinks to one
 * "Loading..." row while it is re-read makes the page shorter, the browser pulls the view up, and
 * when the rows come back the operator is looking at the top of the page. This wrapper measures its
 * own height after every render while `hold` is false, and while `hold` is true keeps at least that
 * height, so a read in flight can never move the view. When the read lands the hold drops and the
 * page takes whatever height the new rows need: a genuinely shorter list still shortens the page.
 */
export function HeldHeight({ hold, children }: { hold: boolean; children: ReactNode }): JSX.Element {
  const ref = useRef<HTMLDivElement>(null);
  const last = useRef(0);
  useLayoutEffect(() => {
    if (!hold && ref.current) last.current = ref.current.offsetHeight;
  });
  return (
    <div ref={ref} data-testid="held-height" style={hold && last.current > 0 ? { minHeight: last.current } : undefined}>
      {children}
    </div>
  );
}
